<div *ngFor="let section of sections">
  <h3>{{ section.title }}</h3>
  <div [innerHTML]="section.body | mdToHtml"></div>

  <div *ngIf="(section?.xmlDataArray)!.length > 0">
    <div class="xml-accordion" *ngFor="let xmlData of section.xmlDataArray">
      <details class="p-2">
        <summary class="underline">
          {{ xmlData.xmlTitle }}
        </summary>
        <div class="xml-content">
          <app-prism-xml [xmlData]="xmlData.xmlData"></app-prism-xml>
        </div>
      </details>
    </div>
  </div>
</div>
